import { useMutation, useQueryClient } from "@tanstack/react-query";

interface AcceptTermsResponse {
  acceptedTermsAt: string;
  termsVersion: string;
}

const API_BASE = import.meta.env.VITE_API_URL || "";

export function useAcceptTerms() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (termsVersion: string): Promise<AcceptTermsResponse> => {
      const response = await fetch(`${API_BASE}/api/user/accept-terms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ termsVersion }),
      });

      if (!response.ok) {
        throw new Error("Failed to accept terms");
      }

      return response.json();
    },
    onSuccess: () => {
      // Invalidate current user to refetch with updated terms acceptance
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });
    },
  });
}
